import { GeoFlag, UkFlag } from '../Flags';
// MobileMenu.jsx
import React, { Fragment, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link, useLocation } from 'react-router-dom';

const MobileMenu = () => {
    const { t, i18n } = useTranslation();
    const location = useLocation();
    const [openId, setOpenId] = useState(0);

    const ClickHandler = () => {
        window.scrollTo(10, 0);
    };

    const changeLanguage = (lng) => {
        i18n.changeLanguage(lng);
        // Update URL to reflect language change
        const pathParts = location.pathname.split('/');
        pathParts[1] = lng;
        const newPath = pathParts.join('/');
        window.location.href = newPath;
    };

    // Define menu items using translation keys
    const allMenus = [
        {
            id: 1,
            title: t('navigation.home'),
            link: `/${i18n.language}`,
            hideInKa: true,
        },
        {
            id: 2,
            title: t('navigation.about'),
            link: `/${i18n.language}/about`,
        },
        {
            id: 3,
            title: t('navigation.services'),
            link: `/${i18n.language}/services`,
        },
        {
            id: 3.5,
            title: t('navigation.products') || (i18n.language === 'ka' ? 'პროდუქტები' : 'Products'),
            link: `/${i18n.language}/products`,
        },
        {
            id: 4,
            title: t('navigation.portfolio'),
            link: `/${i18n.language}/portfolio`,
        },
        {
            id: 5,
            title: t('navigation.blog') || 'Blog',
            link: `/${i18n.language}/blog`,
            hideInKa: true,
        },
        {
            id: 6,
            title: t('navigation.contact'),
            link: `/${i18n.language}/contact`,
        },
    ];

    const menus = i18n.language === 'ka'
        ? allMenus.filter(item => !item.hideInKa)
        : allMenus;

    return (
        <ul className="xb-menu-primary clearfix">
            {menus.map((item, mn) => {
                return (
                    <li className={item.id === openId ? 'active' : ''} key={mn}>
                        {item.submenu ? (
                            <Fragment>
                                <p onClick={() => setOpenId(item.id === openId ? 0 : item.id)}>
                                    {item.title}
                                    <i className={item.id === openId ? 'fa fa-angle-up' : 'fa fa-angle-down'}></i>
                                </p>
                                <div className={`submenu ${item.id === openId ? 'open' : ''}`}>
                                    {item.submenu.map((submenu, i) => (
                                        <Link
                                            key={i}
                                            onClick={ClickHandler}
                                            to={submenu.link}
                                        >
                                            {submenu.title}
                                        </Link>
                                    ))}
                                </div>
                            </Fragment>
                        ) : (
                            <Link onClick={ClickHandler} to={item.link}>
                                {item.title}
                            </Link>
                        )}
                    </li>
                );
            })}

            {/* Language Switcher in Mobile Menu */}
            <li className="mobile-language-switcher">
                <div className="language-options">
                    <button
                        onClick={() => changeLanguage('en')}
                        className={i18n.language === 'en' ? 'active' : ''}
                        aria-label="Switch to English"
                        title="English"
                    >
                        <UkFlag size={20} />
                    </button>
                    <button
                        onClick={() => changeLanguage('ka')}
                        className={i18n.language === 'ka' ? 'active' : ''}
                        aria-label="Switch to Georgian"
                        title="ქართული"
                    >
                        <GeoFlag size={20} />
                    </button>
                </div>
            </li>
        </ul>
    );
};

export default MobileMenu;